import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';

import { Transportadora } from '../transportadora';

@Injectable({
    providedIn: 'root'
})
export class TypeaheadTransportadoraHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/transportadora`
    }

    /** Pesquisa todas as transportadoras cadastradas para o typeahead */
    search(nomeCodigoCnpjCpf: string, situacao: number, limit: number): Observable<Transportadora[]> {
        // Params
        let params = new HttpParams()
                            .append('nomeCodigoCnpjCpf', nomeCodigoCnpjCpf); // Nome, código e CNPJ/CPF
        // Situação
        if (situacao) {
            params = params.append('situacao', situacao.toString());
        }
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);

        return this.customHttp.get<Transportadora[]>(this.pathApi, {params});
    }
}
